const parseHourLabel = (label) => {
  if (typeof label !== "string") return null;

  const match = label.trim().match(/^(\d{1,2})\s*(AM|PM)$/i);
  if (!match) return null;

  const hour = Number(match[1]);
  const period = match[2].toUpperCase();

  if (period === "AM") return hour === 12 ? 0 : hour;
  return hour === 12 ? 12 : hour + 12;
};

export const normalizeTimeOfDayChart = ({ data = [], xLabels = [], yLabels = [] } = {}) => {
  const startHour = parseHourLabel(yLabels[0]);
  const isLegacySparseMatrix =
    Number.isInteger(startHour) && data.length > yLabels.length && Array.isArray(data[startHour]);
  const sourceData =
    isLegacySparseMatrix ? data.slice(startHour) : data;

  return {
    xLabels,
    yLabels,
    data: yLabels.map((_, rowIndex) =>
      xLabels.map((__, columnIndex) => Number(sourceData?.[rowIndex]?.[columnIndex]) || 0)
    ),
  };
};
